import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {RESTService} from "../../services/rest.service";
import {StorageService} from "../../services/storage.service";
import {GlobalStorageService} from "../../services/global-storage.service";
import {IndexedDB} from "../../services/indexed-db.service";
import {UtilsService} from "../../services/utils.service";

@Component({
  selector: 'app-follow-up',
  templateUrl: './follow-up.component.html',
  styleUrls: ['./follow-up.component.scss'],
  standalone: false
})

export class FollowUpComponent implements OnChanges {
  @Input() data: any = {};
  @Input() isPreviousVisit: boolean = false;
  @Input() isFollowUpControlsBlockVisible: boolean = false;

  @Output() statusChange = new EventEmitter<boolean>();

  followUpNotes: any = {
    picturesAndNotes: [],
    flow: [],
    siteInventory: [],
    trainings: [],
    services: [],
    educationModules: []
  };
  isDataExist: boolean = true;
  siteVisit: any = {};
  isShowImageShareButton: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private rest: RESTService,
    private storage: StorageService,
    public global: GlobalStorageService,
    private utils: UtilsService,
    private db: IndexedDB) {
  }

  async getImage(note: any) {
    if (this.global.get('isOffline')) {
      return note.filename ? await this.utils.readFile(note.filename) : (note.photoLink ? this.utils.getDefaultImage() : '');
    } else {
      return note.filename ? await this.utils.readFile(note.filename) : (note.photoLink ? note.photoLink : '');
    }
  }

  onStatusChange(value: boolean) {
    this.statusChange.emit(value);
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['data'] && changes['data'].currentValue && changes['data'].currentValue.id) {
      let data: any = Object.assign({}, changes['data'].currentValue);

      /* Trainings */
      let trainings: any = [];
      if (data.followUpNotes?.trainings?.length) {
        data.followUpNotes.trainings.map((item: any) => {
          item.isPreviousVisit = true;
        });
        trainings = trainings.concat(data.followUpNotes.trainings);

        for (let item of trainings) {
          for (let comment of item.comments) {
            for (let n of comment.notes) {
              n.img = await this.getImage(n);
            }
          }
        }
      }
      if (data.trainingCategories?.length && !data.isOnlineData) {
        for (let item of data.trainingCategories) {
          const comments = [];
          for (let comment of item.comments) {
            if (comment.isTrue) {
              if (!comment.notes?.length && comment.notesIds?.length) {
                let notes: any = await this.db.readItemsByIds('notes', comment.notesIds);
                comment.notes = this.utils.modifyNotes(notes) || [];
              }
              comment.notes = comment.notes.filter((item: any) => {
                if (this.isPreviousVisit) {
                  return item.typeOfNote === "Internal Note" && !item.isCompleted;
                } else {
                  return item.typeOfNote === "Internal Note";
                }
              });
              for (let n of comment.notes) {
                n.img = await this.getImage(n);
              }
              if (comment.notes.length) {
                comments.push(comment);
              }
            }
          }
          if (comments.length) {
            trainings.push({category: item.name, comments});
          }
        }
      }

      /* Services */
      let services: any = [];
      if (data.followUpNotes?.services?.length) {
        data.followUpNotes.services.map((item: any) => {
          item.isPreviousVisit = true;
        });
        services = services.concat(data.followUpNotes.services);

        for (let item of services) {
          for (let comment of item.comments) {
            for (let n of comment.notes) {
              n.img = await this.getImage(n);
            }
          }
        }
      }
      if (data.serviceCategories?.length && !data.isOnlineData) {
        for (let item of data.serviceCategories) {
          const comments = [];
          for (let comment of item.comments) {
            if (comment.isTrue) {
              if (!comment.notes?.length && comment.notesIds?.length) {
                let notes: any = await this.db.readItemsByIds('notes', comment.notesIds);
                comment.notes = this.utils.modifyNotes(notes) || [];
              }
              comment.notes = comment.notes.filter((item: any) => {
                if (this.isPreviousVisit) {
                  return item.typeOfNote === "Internal Note" && !item.isCompleted;
                } else {
                  return item.typeOfNote === "Internal Note";
                }
              });
              for (let n of comment.notes) {
                n.img = await this.getImage(n);
              }
              if (comment.notes.length) {
                comments.push(comment);
              }
            }
          }
          if (comments.length) {
            services.push({category: item.name, comments});
          }
        }
      }

      /* Education Modules */
      let educationModules: any = [];
      if (data.followUpNotes?.educationModules?.length) {
        data.followUpNotes.educationModules.map((item: any) => {
          item.isPreviousVisit = true;
        });

        educationModules = educationModules.concat(data.followUpNotes.educationModules);
        for (let item of educationModules) {
          for (let comment of item.comments) {
            for (let n of comment.notes) {
              n.img = await this.getImage(n);
            }
          }
        }
      }
      if (data.educationModulesCategories?.length && !data.isOnlineData) {
        for (let item of data.educationModulesCategories) {
          const comments = [];
          if (item.comments?.length) {
            for (let comment of item.comments) {
              if (comment.isTrue) {
                if (!comment.notes?.length && comment.notesIds?.length) {
                  let notes: any = await this.db.readItemsByIds('notes', comment.notesIds);
                  notes = this.utils.modifyNotes(notes);
                  comment.notes = this.utils.modifyNotes(notes) || [];
                }
                comment.notes = comment.notes.filter((item: any) => {
                  if (this.isPreviousVisit) {
                    return item.typeOfNote === "Internal Note" && !item.isCompleted;
                  } else {
                    return item.typeOfNote === "Internal Note";
                  }
                });
                for (let n of comment.notes) {
                  n.img = await this.getImage(n);
                }
                if (comment.notes.length) {
                  comments.push(comment);
                }
              }
            }
          }
          if (comments.length) {
            educationModules.push({category: item.name, comments});
          }
        }
      }

      let picturesAndNotes: any = [];
      if (data.followUpNotes?.picturesAndNotes?.length) {
        data.followUpNotes.picturesAndNotes.map((item: any) => {
          item.isPreviousVisit = true;
        });
        const followUpPicturesAndNotes = picturesAndNotes.concat(data.followUpNotes.picturesAndNotes);

        for (let n of followUpPicturesAndNotes) {
          n.img = await this.getImage(n);
          picturesAndNotes.push(n);
        }
      }
      if (data.picturesAndNotes?.length && !data.isOnlineData) {
        picturesAndNotes = picturesAndNotes.concat(await this.db.readItemsByIds('notes', data.picturesAndNotes) || []);
      }
      picturesAndNotes = this.utils.modifyNotes(picturesAndNotes);
      picturesAndNotes = picturesAndNotes.filter((item: any) => {
        if (this.isPreviousVisit) {
          return item.typeOfNote === "Internal Note" && item.noteSource === 'Pictures and Notes' && !item.isCompleted;
        } else {
          return item.typeOfNote === "Internal Note" && item.noteSource === 'Pictures and Notes';
        }
      });
      if (!data.isOnlineData) {
        for (let picture of picturesAndNotes) {
          picture.img = await this.getImage(picture);
        }
      }

      let flow: any = [];
      if (data.followUpNotes?.flow?.length) {
        data.followUpNotes.flow = data.followUpNotes.flow.map((item: any) => {
          item.isPreviousVisit = true;
          return item;
        });
        flow = flow.concat(data.followUpNotes.flow);
      }
      if (data.questions?.length && !data.isOnlineData) {
        flow = flow.concat(data.questions?.length ? data.questions.filter((item: any) => item.answer) : []);
      }
      for (let f of flow) {
        f.isVisible = false;

        if (f['noteID'] && !f.note?.id) {
          f.note = await this.db.readItem('notes', f['noteID']);
        }
        if (f.note?.id) {
          f.note = this.utils.modifyNote(f.note);
          if (this.isPreviousVisit) {
            if (f.note.typeOfNote === "Internal Note" && !f.note.isCompleted) {
              f.isVisible = true;
            } else {
              f.note = {};
              f.noteID = "";
            }
          } else {
            if (f.note.typeOfNote === "Internal Note") {
              f.isVisible = true;
            } else {
              f.note = {};
              f.noteID = "";
            }
          }
        }

        if (!f.additionalNotes?.length) {
          let additionalNotes: any = await this.db.readItemsByIds('notes', f['additionalNotesIds']) || [];
          f.additionalNotes = this.utils.modifyNotes(additionalNotes);
        }

        if (f.additionalNotes?.length) {
          f.additionalNotes = f.additionalNotes.filter((item: any) => {
            if (this.isPreviousVisit) {
              if (item.typeOfNote === "Internal Note" && !item.isCompleted) {
                f.isVisible = true;
                return f.isVisible;
              }
              return false;
            } else {
              f.isVisible = item.typeOfNote === "Internal Note";
              return f.isVisible;
            }
          });
          for (let n of f.additionalNotes) {
            n.img = await this.getImage(n);
            n = this.utils.modifyNote(n);
          }
        }

        if (f.comments?.length) {
          for (let i = 0; i < f.comments.length; i++) {
            if (!f.comments[i].isCompleted) {
              f.comments.splice(i, 1);
              i--;
            }
          }
        }
      }

      flow = this.utils.sort(flow, 'templateCategoryOrder', 1);
      let lastCategory = '';
      for (let f of flow) {
        if (f.isVisible) {
          f.isCategoryVisible = f['templateCategoryOrder'] !== lastCategory;
          lastCategory = f['templateCategoryOrder'];
        }
      }
      flow = flow.filter((item: any) => {
        return item.isVisible;
      });

      let siteInventory: any = [];
      if (data.followUpNotes?.siteInventory?.length) {
        data.followUpNotes.siteInventory.map((item: any) => {
          if (item?.note?.id) {
            item.note.isPreviousVisit = true;
          }
        });
        siteInventory = siteInventory.concat(data.followUpNotes.siteInventory);
      }

      if (data.siteInventory?.length && !data.isOnlineData) {
        siteInventory = siteInventory.concat(data.siteInventory?.length ? data.siteInventory.filter((item: any) => {
          return item.noteID;
        }) : []);
      }
      if (!data.isOnlineData) {
        for (let item of siteInventory) {
          if (!item.note && item['noteID']) {
            item.note = await this.db.readItem('notes', item['noteID']);
          }
        }
      }
      if (this.isPreviousVisit) {
        siteInventory = siteInventory.filter((item: any) => {
          return !item.note?.isCompleted;
        });
      }
      this.followUpNotes.flow = flow || [];
      this.followUpNotes.picturesAndNotes = picturesAndNotes || [];
      this.followUpNotes.trainings = trainings || [];
      this.followUpNotes.services = services || [];
      this.followUpNotes.educationModules = educationModules || [];
      this.followUpNotes.siteInventory = siteInventory || [];

      let isDataExist = false;
      for (let key of Object.keys(this.followUpNotes)) {
        if (this.followUpNotes[key].length) {
          isDataExist = true;
          break;
        }
      }
      this.isDataExist = isDataExist;
      this.siteVisit = this.storage.getItem('siteVisit');
      this.onStatusChange(true);
    } else {
      this.isDataExist = false;
      this.onStatusChange(false);
    }

    this.isShowImageShareButton = Boolean(this.storage.getItem('isShowImageShareButton'));
  }

  async completeUncheckFollowUpNote(note: any, value: boolean, isPreviousVisit: boolean) {
    this.global.set('isLoading', true);
    note.isCompleted = value;

    if (!note.id) {
      note.id = note.portal_id;
    }
    if (isPreviousVisit) {
      const siteVisit: any = this.storage.getItem('siteVisit');
      const visit: any = await this.db.readItem('visits', siteVisit.siteVisitId);
      let foundNote = false;

      for (let item of visit.followUpNotes.picturesAndNotes) {
        if (!item.id) {
          item.id = item.portal_id;
        }
        if (item.id === note.id) {
          item.isCompleted = value;
          item.visitId = siteVisit.siteVisitId;
          item.isPreviousVisit = isPreviousVisit;
          await this.db.updateItem('notes', item.id, item);
          foundNote = true;
          break;
        }
      }

      if (!foundNote) {
        for (let item of visit.followUpNotes.trainings) {
          for (const c of item.comments) {
            for (const n of c.notes) {
              if (!n.id) {
                n.id = n.portal_id;
              }
              if (n.id === note.id) {
                n.isCompleted = value;
                n.visitId = siteVisit.siteVisitId;
                item.isPreviousVisit = isPreviousVisit;
                await this.db.updateItem('notes', n.id, n);
                foundNote = true;
                break;
              }
            }
          }
        }
      }

      if (!foundNote) {
        for (let item of visit.followUpNotes.services) {
          for (const c of item.comments) {
            for (const n of c.notes) {
              if (!n.id) {
                n.id = n.portal_id;
              }
              if (n.id === note.id) {
                n.isCompleted = value;
                n.visitId = siteVisit.siteVisitId;
                item.isPreviousVisit = isPreviousVisit;
                await this.db.updateItem('notes', n.id, n);
                foundNote = true;
                break;
              }
            }
          }
        }
      }

      if (!foundNote) {
        for (let item of visit.followUpNotes.educationModules) {
          for (const c of item.comments) {
            for (const n of c.notes) {
              if (!n.id) {
                n.id = n.portal_id;
              }
              if (n.id === note.id) {
                n.isCompleted = value;
                n.visitId = siteVisit.siteVisitId;
                item.isPreviousVisit = isPreviousVisit;
                await this.db.updateItem('notes', n.id, n);
                foundNote = true;
                break;
              }
            }
          }
        }
      }

      if (!foundNote) {
        if (visit.followUpNotes.siteInventory?.length) {
          for (let item of visit.followUpNotes.siteInventory) {
            if (!item.note?.id) {
              item.note.id = item.note?.portal_id;
            }
            if (item.note?.id === note.id) {
              item.note.isCompleted = value;
              item.note.visitId = siteVisit.siteVisitId;
              item.isPreviousVisit = isPreviousVisit;
              await this.db.updateItem('notes', item.note.id, item.note);
              foundNote = true;
              break;
            }
          }
        }
      }

      if (!foundNote) {
        for (let item of visit.followUpNotes.flow) {
          if (!item.id) {
            item.id = item.portal_id;
          }
          if (item.note && item.note.id === note.id) {
            item.note.isCompleted = value;
            item.note.visitId = siteVisit.siteVisitId;
            item.isPreviousVisit = isPreviousVisit;
            await this.db.updateItem('notes', item.note.id, item.note);
            foundNote = true;
            break;
          }
          for (let additionalNote of item.additionalNotes) {
            if (!additionalNote.id) {
              additionalNote.id = additionalNote.portal_id;
            }
            if (additionalNote.id === note.id) {
              additionalNote.isCompleted = value;
              additionalNote.visitId = siteVisit.siteVisitId;
              item.isPreviousVisit = isPreviousVisit;
              await this.db.updateItem('notes', additionalNote.id, additionalNote);
              foundNote = true;
              break;
            }
          }
        }
      }
      this.db.updateItem('visits', visit.id, visit).then((data: any) => {
        this.global.set('isLoading', false);
      });
    } else {
      this.db.updateItem('notes', note.id, note).then((data: any) => {
        this.global.set('isLoading', false);
      });
    }
  }

  async share(note: any) {
    if (note.filename) {
      await this.utils.shareLocalFile(note.filename);
    } else {
      alert("No local file found");
    }
  }
}
